<!--
@Create By Tim For 19/08/18
@
-->
<template>
  <div class="Menu">
    <ul>
      <li @mouseover="mouseoverTwo(index)" @mouseleave="mouseleaveTwo" v-for="(item, index) in menuList" :key="index">
        {{ item.categoryLabel }}
        <i class="el-icon-arrow-right"></i>
        <div class="menuNav" v-show="menuNav === index">
          <!-- <a
            @click="goToInfo(item)"
            v-for="(items, indexs) in item.children"
            :key="indexs"
            href="javascript:;"
          >
            <p>{{ items.categoryLabel }}</p>
          </a> -->

          <!-- @click="goToInfo(items)" -->
          <li @mouseover="mouseoverChild(indexs)" @mouseleave="mouseleaveChild" v-for="(items, indexs) in item.children" :key="indexs">
            {{ items.categoryLabel }}
            <i class="el-icon-arrow-right"></i>
            <div class="menuNav" v-show="menuNavChild === indexs">
              <a @click="goToInfo(item)" v-for="(itemKs, indexKs) in items.children" :key="indexKs" href="javascript:;">
                <p>{{ itemKs.categoryLabel }}</p>
              </a>
            </div>
          </li>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import Bus from '../../bus';
import axios from 'axios';
import api from '../../../config/api';

export default {
  name: 'Menu',
  data() {
    return {
      // 课程分类导航数据
      menuList: [],
      // 二级目录index
      menuNav: null,
      // 三级目录index
      menuNavChild: null
    };
  },

  created() {
    this.getData();
  },

  methods: {
    // 获取导航课程分类数据
    getData() {
      this.$axios.get(api + 'portal/category/list').then(res => {
        this.menuList = res;
      });
    },

    // 一级菜单鼠标移入
    mouseoverTwo(index) {
      this.menuNav = index;
    },

    // 一级菜单鼠标移出
    mouseleaveTwo() {
      this.menuNav = null;
    },

    // 二级菜单鼠标移入
    mouseoverChild(index) {
      this.menuNavChild = index;
    },
    // 二级菜单鼠标移出
    mouseleaveChild() {
      this.menuNavChild = null;
    },
    // 跳转详情
    goToInfo(data) {
      Bus.$emit('refreshNav', 1);
      this.$router.push({ name: 'AllCourse', params: { category: data.id } });
    }
  }
};
</script>

<style></style>

<style scoped>
.Menu {
  width: 210px;
  height: 320px;
  background: #070626;
  position: relative;
}

.Menu ul {
  width: 210px;
  height: 320px;
}

.Menu ul li {
  width: 190px;
  height: 39px;
  line-height: 40px;
  font-size: 14px;
  text-indent: 15px;
  margin: 0 auto;
  color: #fff;
  border-bottom: 1px solid #393951;
  cursor: pointer;
}

.Menu ul li i {
  float: right;
  color: #fff;
  margin-top: 10px;
}

.Menu .menuNav {
  background: #070626;
  position: absolute;
  top: 0;
  left: 200px;
  z-index: 199;
  width: 210px;
  height: 320px;
}

.Menu .menuNav a {
  text-decoration: none;
}

.Menu .menuNav p {
  height: 39px;
  line-height: 40px;
  font-size: 14px;
  text-indent: 15px;
  color: #fff;
  border-bottom: 1px solid #393951;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Menu.vue